import Helpers from "../utils/helpers";

let leadingOnes = "(255|254|252|248|240|224|192|128|0+)";
let allOnes = "(255.)";
let networkMaskRegex = new RegExp(
  "^((" +
    allOnes +
    "{3}" +
    leadingOnes +
    ")|" +
    "(" +
    allOnes +
    "{2}" +
    leadingOnes +
    ".0+)|" +
    "(" +
    allOnes +
    leadingOnes +
    "(.0+){2})|" +
    "(" +
    leadingOnes +
    "(.0+){3}))$"
);

//  (https?:\/\/)?((www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}|(?:[1-9]\d?|1\d\d|2[01]\d|2[0-5][0-5])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[0-9]\d?|1\d\d|2[0-4]\d|25[0-4])))\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)

export const httpProtocolPattern = "https?:\\/\\/";
export const ftpProtocolPattern = "ftp:\\/\\/";
export const rtspProtocolPattern = "rtsp:\\/\\/";
export const sipProtocolPattern = "sip:";

export const ipAddressPattern =
  "(?:[1-9]\\d?|1\\d\\d|2[01]\\d|2[0-5][0-5])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-5]))";
export const dnsNamePattern =
  "(www\\.)?[-a-zA-Z0-9:%._\\+~#=]{2,256}\\.[a-z]{2,255}";
// export const dnsNamePattern =
//   '(www\\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\\.[a-z]{2,255}'
export const portRangePattern =
  "(:([0-9]{1,4}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5]))";
export const urlAuthPattern =
  "([-a-zA-Z0-9@:%_+.~#?&=]{1,256}(:[-a-zA-Z0-9@:%_+.~#?&=]{1,256})?@)";
export const baseUrlPattern = `((${ipAddressPattern})|${dnsNamePattern})${portRangePattern}?\\b(\\/[-a-zA-Z0-9@:%_\\+.~#?&//=]*)?`;

export const sipNumber = `^sip:[0-9A-Za-z-@.+]@((\\b((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?(?:\\:\\d{1,5})?)(\\.|$)){4}\\b)|([0-9][A-Za-z+\\-]+[0-9])((\\.([0-9][A-Za-z+\\-]+[0-9]*))+\\b))$`;

export const httpUrlPattern = `(${httpProtocolPattern})?${baseUrlPattern}`;
export const ftpUrlPattern = `${ftpProtocolPattern}${urlAuthPattern}?${baseUrlPattern}`;
export const sipUrlPattern = `${sipProtocolPattern}${urlAuthPattern}?${baseUrlPattern}`;
export const rtspUrlPattern = `${rtspProtocolPattern}${urlAuthPattern}?${baseUrlPattern}`;

const HexHypenPattern = "^(([\\da-fA-F]{2})-)+([\\da-fA-F]{2})$";
const HexColonPattern = "^(([\\da-fA-F]{2}):)+([\\da-fA-F]{2})$";

const httpUrlPatternRegex = new RegExp("^" + httpUrlPattern + "$", "i");
const ftpUrlPatternRegex = new RegExp("^" + ftpUrlPattern + "$", "i");
const sipUrlPatternRegex = new RegExp("^" + sipUrlPattern + "$", "i");
const rtspUrlPatternRegex = new RegExp("^" + rtspUrlPattern + "$", "i");

const HexHypen = new RegExp(HexHypenPattern);
const HexColon = new RegExp(HexColonPattern);

export const email_pattern =
  '(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))';
const EmailRegex = new RegExp("^" + email_pattern + "$");

// let sipUrlRegex = new RegExp(
//   /^sip:(([-a-zA-Z0-9%_+.~#?&/=]{1,256}:)?[-a-zA-Z0-9%_+.~#?&/=]{1,256}@)?(?:(?:[1-9]\d?|1\d\d|2[01]\d|2[0-5][0-5])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[0-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s:/]+)*\/?$/iu,
// )

// let httpFtpUrlRegex = new RegExp(
//   /^(?:(?:https?|ftp):\/\/)?(?:(?:[1-9]\d?|1\d\d|2[01]\d|2[0-5][0-5])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[0-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s:/]+)*\/?$/iu,
// )

let logicalAddressRegex = new RegExp(/^\d+-\d+-\d+[0-9]{2}$/);

// let rtspUrlRegex = new RegExp(
//   /^rtsp:\/\/([-a-zA-Z0-9@:%_+.~#?&=]{1,256}:[-a-zA-Z0-9@:%_+.~#?&=]{1,256}@)?(?:(?:[1-9]\d?|1\d\d|2[01]\d|2[0-5][0-5])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[0-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)(?:\.(?:[a-z\u{00a1}-\u{ffff}0-9]+-?)*[a-z\u{00a1}-\u{ffff}0-9]+)*(?:\.(?:[a-z\u{00a1}-\u{ffff}]{2,})))(?::\d{2,5})?(?:\/[^\s:/]+)*\/?$/iu,
// )

let ipv4Regex = new RegExp(
  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
);

export const alphaNumericMask =
  "A-Za-zªµºÀ-ÖØ-öø-ˁˆ-ˑˠ-ˤˬˮͰ-ʹͶͷͺ-ͽͿΆΈ-ΊΌΎ-ΡΣ-ϵϷ-ҁҊ-ԯԱ-Ֆՙա-ևא-תװ-ײؠ-يٮٯٱ-ۓەۥۦۮۯۺ-ۼۿܐܒ-ܯݍ-ޥޱߊ-ߪߴߵߺࠀ-ࠕࠚࠤࠨࡀ-ࡘࢠ-ࢴऄ-हऽॐक़-ॡॱ-ঀঅ-ঌএঐও-নপ-রলশ-হঽৎড়ঢ়য়-ৡৰৱਅ-ਊਏਐਓ-ਨਪ-ਰਲਲ਼ਵਸ਼ਸਹਖ਼-ੜਫ਼ੲ-ੴઅ-ઍએ-ઑઓ-નપ-રલળવ-હઽૐૠૡૹଅ-ଌଏଐଓ-ନପ-ରଲଳଵ-ହଽଡ଼ଢ଼ୟ-ୡୱஃஅ-ஊஎ-ஐஒ-கஙசஜஞடணதந-பம-ஹௐఅ-ఌఎ-ఐఒ-నప-హఽౘ-ౚౠౡಅ-ಌಎ-ಐಒ-ನಪ-ಳವ-ಹಽೞೠೡೱೲഅ-ഌഎ-ഐഒ-ഺഽൎൟ-ൡൺ-ൿඅ-ඖක-නඳ-රලව-ෆก-ะาำเ-ๆກຂຄງຈຊຍດ-ທນ-ຟມ-ຣລວສຫອ-ະາຳຽເ-ໄໆໜ-ໟༀཀ-ཇཉ-ཬྈ-ྌက-ဪဿၐ-ၕၚ-ၝၡၥၦၮ-ၰၵ-ႁႎႠ-ჅჇჍა-ჺჼ-ቈቊ-ቍቐ-ቖቘቚ-ቝበ-ኈኊ-ኍነ-ኰኲ-ኵኸ-ኾዀዂ-ዅወ-ዖዘ-ጐጒ-ጕጘ-ፚᎀ-ᎏᎠ-Ᏽᏸ-ᏽᐁ-ᙬᙯ-ᙿᚁ-ᚚᚠ-ᛪᛱ-ᛸᜀ-ᜌᜎ-ᜑᜠ-ᜱᝀ-ᝑᝠ-ᝬᝮ-ᝰក-ឳៗៜᠠ-ᡷᢀ-ᢨᢪᢰ-ᣵᤀ-ᤞᥐ-ᥭᥰ-ᥴᦀ-ᦫᦰ-ᧉᨀ-ᨖᨠ-ᩔᪧᬅ-ᬳᭅ-ᭋᮃ-ᮠᮮᮯᮺ-ᯥᰀ-ᰣᱍ-ᱏᱚ-ᱽᳩ-ᳬᳮ-ᳱᳵᳶᴀ-ᶿḀ-ἕἘ-Ἕἠ-ὅὈ-Ὅὐ-ὗὙὛὝὟ-ώᾀ-ᾴᾶ-ᾼιῂ-ῄῆ-ῌῐ-ΐῖ-Ίῠ-Ῥῲ-ῴῶ-ῼⁱⁿₐ-ₜℂℇℊ-ℓℕℙ-ℝℤΩℨK-ℭℯ-ℹℼ-ℿⅅ-ⅉⅎↃↄⰀ-Ⱞⰰ-ⱞⱠ-ⳤⳫ-ⳮⳲⳳⴀ-ⴥⴧⴭⴰ-ⵧⵯⶀ-ⶖⶠ-ⶦⶨ-ⶮⶰ-ⶶⶸ-ⶾⷀ-ⷆⷈ-ⷎⷐ-ⷖⷘ-ⷞⸯ々〆〱-〵〻〼ぁ-ゖゝ-ゟァ-ヺー-ヿㄅ-ㄭㄱ-ㆎㆠ-ㆺㇰ-ㇿ㐀-䶵一-鿕ꀀ-ꒌꓐ-ꓽꔀ-ꘌꘐ-ꘟꘪꘫꙀ-ꙮꙿ-ꚝꚠ-ꛥꜗ-ꜟꜢ-ꞈꞋ-ꞭꞰ-ꞷꟷ-ꠁꠃ-ꠅꠇ-ꠊꠌ-ꠢꡀ-ꡳꢂ-ꢳꣲ-ꣷꣻꣽꤊ-ꤥꤰ-ꥆꥠ-ꥼꦄ-ꦲꧏꧠ-ꧤꧦ-ꧯꧺ-ꧾꨀ-ꨨꩀ-ꩂꩄ-ꩋꩠ-ꩶꩺꩾ-ꪯꪱꪵꪶꪹ-ꪽꫀꫂꫛ-ꫝꫠ-ꫪꫲ-ꫴꬁ-ꬆꬉ-ꬎꬑ-ꬖꬠ-ꬦꬨ-ꬮꬰ-ꭚꭜ-ꭥꭰ-ꯢ가-힣ힰ-ퟆퟋ-ퟻ豈-舘並-龎ﬀ-ﬆﬓ-ﬗיִײַ-ﬨשׁ-זּטּ-לּמּנּסּףּפּצּ-ﮱﯓ-ﴽﵐ-ﶏﶒ-ﷇﷰ-ﷻﹰ-ﹴﹶ-ﻼＡ-Ｚａ-ｚｦ-ﾾￂ-ￇￊ-ￏￒ-ￗￚ-ￜ0-9";
let alphaNumericRegex = new RegExp("^[" + alphaNumericMask + "]*$", "i");
let alphaNumericSpaceRegex = new RegExp(
  "^[" + alphaNumericMask + "\\s]*$",
  "i"
);

let numberRegex = new RegExp(/^[0-9]+$/);

let hybridUriRegex = new RegExp(/^(laskomex:\d+|vizit:\d+)$/);

let macRegex = new RegExp(/^([0-9A-F]{2}[:-]){5}([0-9A-F]{2})$/);

const sipNumberRegex = new RegExp(
  `^[0-9A-Za-z-]+@((${ipAddressPattern})|${dnsNamePattern})$`
);
const sipNumberSimpleRegex = new RegExp(`^[a-zA-Z0-9-]+$`);

export function getErrorFrom(validatinField) {
  return validatinField.error ? [validatinField.error] : [];
}

export function validate(value, field, revalidateEnabled = true) {
  for (const [ruleName, rule] of Object.entries(field.rules)) {
    if (typeof rules[ruleName] === "function" || ruleName === "custom") {
      let ruleParams = { ...field.rules[ruleName], revalidateEnabled };

      let valueForCheck = ruleParams["value"] ? ruleParams["value"]() : value;

      let res = { result: false, errorCode: undefined };

      if (ruleName === "custom") {
        const { result, errorCode } = rule.validator(valueForCheck);
        res.result = result;
        res.errorCode = errorCode;
      } else {
        res.result = rules[ruleName](valueForCheck, ruleParams);
        res.errorCode = field.rules[ruleName].error;
      }

      if (res.result) {
        field.validated = true;
        field.error = undefined;
      } else {
        field.validated = false;
        field.error = res.errorCode;
        return false;
      }
    }
  }
  if (revalidateEnabled && field.revalidate) {
    field.revalidate();
  }
  return true;
}

const rules = {
  replaceErrorCodesWithTranslates(rules) {
    // eslint-disable-next-line no-unused-vars
    for (const [key, rule] of Object.entries(rules)) {
      if (rule.error) {
        rule.error = Helpers.getParameterizedString(
          this.$t("validation." + rule.error),
          rule.errorParams
        );
      }
    }
  },
  validate,
  required(value) {
    return !Helpers.isNull(value) && value !== undefined && value !== "";
  },
  custom(value, { validator }) {
    if (typeof validator !== "function") {
      return false;
    }
    if (value === null || value === undefined) {
      return true;
    }
    const { result, errorCode } = validator(value);
    return { result, errorCode };
  },
  numbers(value, { min, max }) {
    if (value === null || value === undefined) {
      return true;
    }
    return (
      !isNaN(value) &&
      (!this.required(min) || parseInt(value) >= min) &&
      (!this.required(max) || parseInt(value) <= max)
    );
  },
  ascii(value) {
    return !Helpers.isNull(value)
      ? !value
          .split("")
          .find((c) => c.charCodeAt(0) > 126 || c.charCodeAt(0) < 33)
      : null;
  },
  onlyNumbers(value) {
    return !Helpers.isNull(value) ? numberRegex.test(value) : true;
  },
  alphanumeric(value, { space = true }) {
    return !Helpers.isNull(value)
      ? space
        ? alphaNumericSpaceRegex.test(value)
        : alphaNumericRegex.test(value)
      : true;
  },
  isEmail(value) {
    return value ? EmailRegex.test(String(value).toLowerCase()) : true;
  },
  maxLength(value, { length }) {
    return !Helpers.isNull(value) ? String(value).length <= length : true;
  },
  minLength(value, { length }) {
    return !Helpers.isNull(value) ? String(value).length >= length : true;
  },
  minArrayLength(value, { length }) {
    return !Helpers.isNull(value) ? value.length >= length : true;
  },
  ip_v4(value) {
    return !value || ipv4Regex.test(value);
  },
  networkMask(value) {
    return !value || networkMaskRegex.test(value);
  },
  url(value) {
    return (
      !value ||
      httpUrlPatternRegex.test(value) ||
      ftpUrlPatternRegex.test(value)
    );
  },
  url_ip(value) {
    return !value || this.url(value);
  },
  reg_exp(value, { expression }) {
    return new RegExp(expression).test(value);
  },
  hex(value) {
    return !value || HexHypen.test(value) || HexColon.test(value);
  },
  card_ukey(value) {
    return !value || this.onlyNumbers(value) || this.hex(value);
  },
  forward_number(value) {
    return (
      !value ||
      hybridUriRegex.test(value) ||
      this.sip_url(value) ||
      numberRegex.test(value)
    );
  },
  sipUserSimple(value) {
    return sipNumberSimpleRegex.test(value);
  },
  sipUser(value) {
    return sipNumberRegex.test(value) || this.sipUserSimple(value);
  },
  sip_url(value) {
    return (
      !value ||
      sipUrlPatternRegex.test(value) ||
      logicalAddressRegex.test(value)
    );
  },
  mac(value) {
    return !value || macRegex.test(value);
  },
  rtsp_or_http(value) {
    return this.rtsp_url(value) || this.url(value);
  },
  rtsp_url(value) {
    return value.indexOf("rtsp") === 0
      ? rtspUrlPatternRegex.test(value)
      : false;
  },
  dir(value) {
    return new RegExp("^(.+)/([^/]+)$").test(value);
  },
  equal(field, { val }) {
    return field == val();
  },
  greaterThan(field, { val }) {
    let value = val();
    if (value === null || value === undefined) {
      return true;
    }
    return field > value;
  },
  greater(field, { min }) {
    if (min === null || min === undefined) {
      return true;
    }
    return field > min;
  },
  lessThan(field, { val }) {
    let value = val();
    if (value === null || value === undefined) {
      return true;
    }
    return field < value;
  },
  sectionValidationStatus(section) {
    if (this.validation) {
      for (let i in this.validation[section]) {
        if (Array.isArray(this.validation[section])) {
          for (let j in this.validation[section][i]) {
            if (this.validation[section][i][j].error) {
              return false;
            }
          }
        } else {
          if (this.validation[section][i].error) {
            return false;
          }
        }
      }
    }
    return true;
  },
};

export default rules;
